/**
 * Write-off reason codes. The set is closed, like the ledger's reason codes: a new reason
 * is a code change (and a new app release), never free text. `other` needs a note.
 * Stations get the list from this package, so there is nothing to sync.
 * @module
 */

/** Why stock was written off. */
export const WRITE_OFF_REASONS = ['expired', 'damaged', 'quality', 'other'] as const;
/** One of {@link WRITE_OFF_REASONS}. */
export type WriteOffReason = (typeof WRITE_OFF_REASONS)[number];

/** People-facing labels (SA English). */
export const WRITE_OFF_REASON_LABELS: Readonly<Record<WriteOffReason, string>> = {
  expired: 'Expired',
  damaged: 'Damaged',
  quality: 'Quality problem',
  other: 'Other',
};

/** True when `reason` needs a note (only `other`). */
export function writeOffNeedsNote(reason: WriteOffReason): boolean {
  return reason === 'other';
}
